import { makeStyles } from '@material-ui/styles';

export const useStyles = (styles = () => {}, props = {}) => {
  return makeStyles(styles)(props);
};

